const folderContactKeys = {
  all: ['folderContact'],
  byFolderId: (id: string) => [...folderContactKeys.all, id]
};

export default folderContactKeys;
